// events.ts

import { BaseEvents } from '@/shared/utils';
import { AuthUser } from './types/auth';
import { Auth } from 'firebase/auth';
import { CheckoutAfterLogin } from './types/checkout-after-login';

export const AuthEventKeys = {
  login: {
    view: 'auth/login/view',
    do: 'auth/login/do',
    success: 'auth/login/success',
    error: 'auth/login/error',
    go: 'auth/login/go',
  },
  oidcLogin: {
    view: 'auth/oidcLogin/view',
    do: 'auth/oidcLogin/do',
    error: 'auth/oidcLogin/error',
  },
  logout: 'auth/logout',
  register: {
    view: 'auth/register/view',
    do: 'auth/register/do',
    success: 'auth/register/success',
    error: 'auth/register/error',
  },
  completeRegistration: {
    view: 'auth/completeRegistration/view',
    do: 'auth/completeRegistration/do',
    success: 'auth/completeRegistration/success',
    error: 'auth/completeRegistration/error',
  },
  resendRegistration: {
    do: 'auth/resendRegistration/do',
  },
  activate: {
    view: 'auth/activate/view',
    do: 'auth/activate/do',
    success: 'auth/activate/success',
    error: 'auth/activate/error',
  },
  forgotPassword: {
    view: 'auth/forgotPassword/view',
    do: 'auth/forgotPassword/do',
    success: 'auth/forgotPassword/success',
    error: 'auth/forgotPassword/error',
  },
  newPassword: {
    view: 'auth/newPassword/view',
    do: 'auth/newPassword/do',
    success: 'auth/newPassword/success',
    error: 'auth/newPassword/error',
  },
  updatePassword: {
    view: 'auth/updatePassword/view',
    do: 'auth/updatePassword/do',
    success: 'auth/updatePassword/success',
    error: 'auth/updatePassword/error',
  },
} as const;

export interface AuthEvents extends BaseEvents {
  'auth/login/view': void;
  'auth/login/do': { email: string; password: string; auth: Auth };
  'auth/login/success': { user: AuthUser; checkoutAfterLoginObj?: CheckoutAfterLogin };
  'auth/login/go': void;
  'auth/login/error': Error;
  'auth/oidcLogin/view': void;
  'auth/oidcLogin/do': { email?: string; password?: string; token?: string };
  'auth/oidcLogin/error': Error;
  'auth/logout': void;
  'auth/forgotPassword/view': void;
  'auth/forgotPassword/do': string;
  'auth/forgotPassword/success': void;
  'auth/forgotPassword/error': Error;
  'auth/register/view': void;
  'auth/register/do': { email: string; password: string; name: string; auth: Auth };
  'auth/resendRegistration/do': { email: string; name: string };
  'auth/register/success': void;
  'auth/register/error': Error;
  'auth/activate/view': void;
  'auth/activate/do': { activationCode: string; auth: Auth };
  'auth/activate/success': void;
  'auth/activate/error': Error;
  'auth/newPassword/view': void;
  'auth/newPassword/do': { password: string; confirmPassword: string; oobCode: string; auth: Auth };
  'auth/newPassword/success': void;
  'auth/newPassword/error': Error;
  'auth/updatePassword/view': void;
  'auth/updatePassword/do': {
    password: string;
    confirmPassword: string;
    email: string;
    auth: Auth;
  };
  'auth/updatePassword/success': void;
  'auth/updatePassword/error': Error;

  'auth/completeRegistration/view': void;
  'auth/completeRegistration/do': {
    email: string;
    password: string;
    name: string;
    auth: Auth;
    oobCode: string;
  };
  'auth/completeRegistration/success': void;
  'auth/completeRegistration/error': Error;
}
